import React from "react";
const PDFViewer = ({ pdfUrl, fileUrl, title = "PDF document", iframeRef, onLoad }) => {
  const source = pdfUrl || fileUrl;

  return (
    <div className="pdf-viewer">

      {source && (
        <iframe
          ref={iframeRef}
          onLoad={onLoad}
          src={source}
          title={title}
          width="100%"
          height="100%"
          style={{ border: "none", minHeight: 200 }}
        />
      )}
    </div>
  );
};

export default PDFViewer;
